export function formatForApiGetRequestIfBoolean(v: boolean): string;
export function formatForApiGetRequestIfBoolean<T>(v: T): T;
export function formatForApiGetRequestIfBoolean(v: unknown) {
	if (typeof v === "boolean") {
		return v ? "1" : "0";
	}
	return v;
}
